import React, {useMemo, useEffect, useState, useRef} from 'react'
import * as ReactDOM from 'react-dom/client';
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";


function lightbox({script}){
	function YouTube({slide, offset, ind, autoplay}){
		const url = useMemo(()=>{
			if(offset === 0){
				if(ind === autoplay.current && !script.isSafari){
					autoplay.current = -1
					return slide.src+'?autoplay=1'
				}else{
					return slide.src
				}
			}else{
				return ''
			}

		},[slide, offset, ind, autoplay])
		return (
			<iframe className="airtheme-embed-youtube" width="560" height="315" src={url} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen={true}></iframe>
		)
	}
	function Vimeo({slide, offset, ind, autoplay}){
		const url = useMemo(()=>{
			if(offset === 0){
				if(ind === autoplay.current && !script.isSafari){
					autoplay.current = -1
					return slide.src+'?autoplay=1'
				}else{
					return slide.src
				}
			}else{
				return ''
			}

		},[slide, offset, ind, autoplay])
		return (
			<>
				<iframe className="airtheme-embed-vimeo" width="560" height="315" src={url} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen={true}></iframe><script src="https://player.vimeo.com/api/player.js"></script>
			</>
		)
	}
	function Spotify({slide, offset}){
		const url = useMemo(()=>{
			if(offset === 0){
				return slide.src
			}else{
				return ''
			}
		},[slide, offset])
		return (
			<iframe className="airtheme-embed-spotify" style={{borderRadius: '12px'}} src={url} width="100%" height="352" frameBorder="0" allowFullScreen={true} allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
		)
	}
	function Audiomack({slide, offset}){
		const {url, title, height, className} = useMemo(()=>{
			const res = {url: offset === 0 ? slide.src : ''}
			if(slide.type === 'airthemeAudiomackSong'){
				res.title = 'Song'
				res.height = '252'
				res.className = 'airtheme-embed-audiomack airtheme-embed-audiomack-song'
			}else if(slide.type === 'airthemeAudiomackAlbum'){
				res.title = 'Album'
				res.height = '400'
				res.className = 'airtheme-embed-audiomack airtheme-embed-audiomack-album'
			}
			return res
		},[slide, offset])
		return (
			<iframe className={className} src={url} scrolling="no" width="100%" height={height} frameBorder="0" title={title}></iframe>
		)
	}
	function Box({items, isZoom, isFullscreen, isSlideshow}){
		const [index, setIndex] = useState(-1);
		const [slides, setSlides] = useState([]);
		const autoplay = useRef(-1);
		const close = ()=>{
			script.fxStart()
			setIndex(-1)
		}
		const render = useMemo(()=>{
			return {
				slide: ({ slide, offset }) => {
					if(slide.type === 'airthemeYoutube'){
						return (<YouTube slide={slide} offset={offset} ind={slide.airthemeInd} autoplay={autoplay} />)
					}else if(slide.type === 'airthemeVimeo'){
						return (<Vimeo slide={slide} offset={offset} ind={slide.airthemeInd} autoplay={autoplay} />)
					}else if(slide.type === 'airthemeSpotify'){
						return (<Spotify slide={slide} offset={offset} />)
					}else if(slide.type === 'airthemeAudiomackSong' || slide.type === 'airthemeAudiomackAlbum'){
						return (<Audiomack slide={slide} offset={offset} />)
					}
				},
				iconPrev: ()=>( <span className="airtheme-button-icon airtheme-nav-icon" dangerouslySetInnerHTML={{__html: '<svg fill="#ffffff" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 584.461 584.46" xml:space="preserve"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <g> <g> <path d="M207.021,286.228c20.184,0,36.601-16.42,36.601-36.604c0-20.184-16.42-36.604-36.601-36.604 c-20.184,0-36.604,16.42-36.604,36.604C170.417,269.808,186.837,286.228,207.021,286.228z"></path> <path d="M292.23,541.858c20.184,0,36.604-16.421,36.604-36.604s-16.42-36.604-36.604-36.604c-20.184,0-36.604,16.42-36.604,36.604 S272.046,541.858,292.23,541.858z"></path> <path d="M207.021,201.02c20.184,0,36.601-16.42,36.601-36.604c0-20.184-16.42-36.601-36.601-36.601 c-20.184,0-36.604,16.42-36.604,36.601C170.417,184.6,186.837,201.02,207.021,201.02z"></path> <path d="M207.021,371.437c20.184,0,36.601-16.42,36.601-36.604s-16.42-36.604-36.601-36.604 c-20.184,0-36.604,16.421-36.604,36.604S186.837,371.437,207.021,371.437z"></path> <path d="M207.021,456.649c20.184,0,36.601-16.42,36.601-36.601c0-20.184-16.42-36.604-36.601-36.604 c-20.184,0-36.604,16.42-36.604,36.604C170.417,440.229,186.837,456.649,207.021,456.649z"></path> <path d="M511.256,249.627c0,20.184,16.42,36.604,36.604,36.604s36.602-16.423,36.602-36.604s-16.42-36.604-36.605-36.604 C527.672,213.024,511.256,229.444,511.256,249.627z"></path> <path d="M292.23,456.649c20.184,0,36.604-16.42,36.604-36.601c0-20.184-16.42-36.604-36.604-36.604 c-20.184,0-36.604,16.42-36.604,36.604C255.626,440.229,272.046,456.649,292.23,456.649z"></path> <path d="M36.604,328.833c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.601-36.604-36.601 C16.42,255.628,0,272.048,0,292.232C0,312.413,16.42,328.833,36.604,328.833z"></path> <path d="M121.812,286.228c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.604-36.604-36.604s-36.601,16.42-36.601,36.604 C85.212,269.808,101.629,286.228,121.812,286.228z"></path> <path d="M121.812,371.437c20.184,0,36.604-16.42,36.604-36.604s-16.42-36.604-36.604-36.604s-36.601,16.421-36.601,36.604 S101.629,371.437,121.812,371.437z"></path> <path d="M462.648,286.228c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.604-36.604-36.604 c-20.186,0-36.605,16.42-36.605,36.604C426.043,269.808,442.467,286.228,462.648,286.228z"></path> <path d="M377.439,286.228c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.604-36.604-36.604s-36.602,16.42-36.602,36.604 C340.838,269.808,357.258,286.228,377.439,286.228z"></path> <path d="M499.252,334.836c0-20.184-16.42-36.604-36.604-36.604c-20.186,0-36.605,16.42-36.605,36.604s16.42,36.604,36.605,36.604 C482.832,371.44,499.252,355.02,499.252,334.836z"></path> <path d="M292.23,371.437c20.184,0,36.604-16.42,36.604-36.604s-16.42-36.604-36.604-36.604c-20.184,0-36.604,16.421-36.604,36.604 S272.046,371.437,292.23,371.437z"></path> <path d="M547.855,298.233c-20.184,0-36.604,16.42-36.604,36.604s16.42,36.604,36.604,36.604c20.186,0,36.605-16.42,36.605-36.604 S568.041,298.233,547.855,298.233z"></path> <path d="M292.23,286.228c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.601-36.604-36.601 c-20.184,0-36.604,16.42-36.604,36.604S272.046,286.228,292.23,286.228z"></path> <path d="M292.23,201.02c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.601-36.604-36.601 c-20.184,0-36.604,16.42-36.604,36.601C255.626,184.6,272.046,201.02,292.23,201.02z"></path> <path d="M292.23,115.811c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.604-36.604-36.604 c-20.184,0-36.604,16.42-36.604,36.604C255.626,99.391,272.046,115.811,292.23,115.811z"></path> <path d="M414.043,334.836c0-20.184-16.42-36.604-36.604-36.604s-36.602,16.42-36.602,36.604s16.42,36.604,36.602,36.604 C397.623,371.437,414.043,355.02,414.043,334.836z"></path> </g> </g> </g></svg>'}} /> ),
				iconNext: ()=>( <span className="airtheme-button-icon airtheme-nav-icon" dangerouslySetInnerHTML={{__html: '<svg style="transform:matrix(-1, 0, 0, 1, 0, 0);" fill="#ffffff" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 584.461 584.46" xml:space="preserve"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <g> <g> <path d="M207.021,286.228c20.184,0,36.601-16.42,36.601-36.604c0-20.184-16.42-36.604-36.601-36.604 c-20.184,0-36.604,16.42-36.604,36.604C170.417,269.808,186.837,286.228,207.021,286.228z"></path> <path d="M292.23,541.858c20.184,0,36.604-16.421,36.604-36.604s-16.42-36.604-36.604-36.604c-20.184,0-36.604,16.42-36.604,36.604 S272.046,541.858,292.23,541.858z"></path> <path d="M207.021,201.02c20.184,0,36.601-16.42,36.601-36.604c0-20.184-16.42-36.601-36.601-36.601 c-20.184,0-36.604,16.42-36.604,36.601C170.417,184.6,186.837,201.02,207.021,201.02z"></path> <path d="M207.021,371.437c20.184,0,36.601-16.42,36.601-36.604s-16.42-36.604-36.601-36.604 c-20.184,0-36.604,16.421-36.604,36.604S186.837,371.437,207.021,371.437z"></path> <path d="M207.021,456.649c20.184,0,36.601-16.42,36.601-36.601c0-20.184-16.42-36.604-36.601-36.604 c-20.184,0-36.604,16.42-36.604,36.604C170.417,440.229,186.837,456.649,207.021,456.649z"></path> <path d="M511.256,249.627c0,20.184,16.42,36.604,36.604,36.604s36.602-16.423,36.602-36.604s-16.42-36.604-36.605-36.604 C527.672,213.024,511.256,229.444,511.256,249.627z"></path> <path d="M292.23,456.649c20.184,0,36.604-16.42,36.604-36.601c0-20.184-16.42-36.604-36.604-36.604 c-20.184,0-36.604,16.42-36.604,36.604C255.626,440.229,272.046,456.649,292.23,456.649z"></path> <path d="M36.604,328.833c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.601-36.604-36.601 C16.42,255.628,0,272.048,0,292.232C0,312.413,16.42,328.833,36.604,328.833z"></path> <path d="M121.812,286.228c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.604-36.604-36.604s-36.601,16.42-36.601,36.604 C85.212,269.808,101.629,286.228,121.812,286.228z"></path> <path d="M121.812,371.437c20.184,0,36.604-16.42,36.604-36.604s-16.42-36.604-36.604-36.604s-36.601,16.421-36.601,36.604 S101.629,371.437,121.812,371.437z"></path> <path d="M462.648,286.228c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.604-36.604-36.604 c-20.186,0-36.605,16.42-36.605,36.604C426.043,269.808,442.467,286.228,462.648,286.228z"></path> <path d="M377.439,286.228c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.604-36.604-36.604s-36.602,16.42-36.602,36.604 C340.838,269.808,357.258,286.228,377.439,286.228z"></path> <path d="M499.252,334.836c0-20.184-16.42-36.604-36.604-36.604c-20.186,0-36.605,16.42-36.605,36.604s16.42,36.604,36.605,36.604 C482.832,371.44,499.252,355.02,499.252,334.836z"></path> <path d="M292.23,371.437c20.184,0,36.604-16.42,36.604-36.604s-16.42-36.604-36.604-36.604c-20.184,0-36.604,16.421-36.604,36.604 S272.046,371.437,292.23,371.437z"></path> <path d="M547.855,298.233c-20.184,0-36.604,16.42-36.604,36.604s16.42,36.604,36.604,36.604c20.186,0,36.605-16.42,36.605-36.604 S568.041,298.233,547.855,298.233z"></path> <path d="M292.23,286.228c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.601-36.604-36.601 c-20.184,0-36.604,16.42-36.604,36.604S272.046,286.228,292.23,286.228z"></path> <path d="M292.23,201.02c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.601-36.604-36.601 c-20.184,0-36.604,16.42-36.604,36.601C255.626,184.6,272.046,201.02,292.23,201.02z"></path> <path d="M292.23,115.811c20.184,0,36.604-16.42,36.604-36.604c0-20.184-16.42-36.604-36.604-36.604 c-20.184,0-36.604,16.42-36.604,36.604C255.626,99.391,272.046,115.811,292.23,115.811z"></path> <path d="M414.043,334.836c0-20.184-16.42-36.604-36.604-36.604s-36.602,16.42-36.602,36.604s16.42,36.604,36.602,36.604 C397.623,371.437,414.043,355.02,414.043,334.836z"></path> </g> </g> </g></svg>'}} /> ),
				iconClose: ()=>( <span className="airtheme-button-icon airtheme-close-icon" dangerouslySetInnerHTML={{__html: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <g data-name="Lager 20" transform="translate(-6 -6)"> <path data-name="Path 23" d="M18.695,16l6.752-6.752a1.886,1.886,0,0,0,0-2.668l-.027-.027a1.886,1.886,0,0,0-2.668,0L16,13.305,9.248,6.553a1.886,1.886,0,0,0-2.668,0l-.027.027a1.886,1.886,0,0,0,0,2.668L13.305,16,6.553,22.752a1.886,1.886,0,0,0,0,2.668l.027.027a1.886,1.886,0,0,0,2.668,0L16,18.695l6.752,6.752a1.886,1.886,0,0,0,2.668,0l.027-.027a1.886,1.886,0,0,0,0-2.668Z" fill="currentColor"></path> </g> </g></svg>'}} /> )
			}
		},[])
		useEffect(()=>{
			const slds = []
			items.forEach((item)=>{
				item.click = (e)=> {
					e.preventDefault();
					e.stopPropagation()
					script.fxStop()
					setIndex(item.ind)
					if(item.type === 'airthemeYoutube' || item.type === 'airthemeVimeo'){
						autoplay.current = item.ind
					}
				}
				item.el.addEventListener('click', item.click)
				slds.push({
					type: item.type,
					src: item.src ? item.src : item.el.href,
					airthemeInd: item.ind
				})
			})
			setSlides(slds)
			return ()=>{
				items.forEach((item)=>{
					item.el.removeEventListener('click', item.click)
				})
			}
		},[items])
		const cls = useMemo(()=>{
			let res = "airtheme-overlay airtheme-overlay-lightbox"
			if(items.length<2){
				res += " airtheme-overlay-lightbox-single"
			}
			return res
		},[items])
		const plugins = useMemo(()=>{
			const res = []
			if(isSlideshow){
				res.push(Slideshow)
			}
			if(isFullscreen){
				res.push(Fullscreen)
			}
			if(isZoom){
				res.push(Zoom)
			}
			return res
		},[isSlideshow, isFullscreen, isZoom])
		return (
			<Lightbox
				className={cls}
				index={index}
				slides={slides}
				open={index >= 0}
				close={close}
				render={render}
				carousel={{
					finite: slides.length < 2
				}}
				plugins={plugins}
			/>
		)
	}
	const boxes = []
	document.querySelectorAll('.airtheme-lightbox').forEach((sec)=>{
		const fnd = (e)=>{
			if(e && e.parentNode && e.parentNode.classList && e.parentNode.classList.contains('airtheme-lightbox')){
				return true
			}else if(!e || e.parentNode === document.body){
				return false
			}else{
				return fnd(e.parentNode)
			}
		}
		if(fnd(sec)){
			return
		}
		const items = []
		let isFullscreen = false
		let isZoom = false
		let isSlideshow = false
		const isAll = sec.classList.contains('airtheme-all-lightbox')
		const isYouTube = isAll || sec.classList.contains('airtheme-youtube-lightbox')
		const isVimeo = isAll || sec.classList.contains('airtheme-vimeo-lightbox')
		const isSpotify = isAll || sec.classList.contains('airtheme-spotify-lightbox')
		const isAudiomack = isAll || sec.classList.contains('airtheme-audiomack-lightbox')
		const isImages = isAll || sec.classList.contains('airtheme-images-lightbox')
		sec.querySelectorAll('a').forEach((el)=>{
			let type;
			let src
			if( isYouTube && (el.href.includes('youtube.com/watch') || el.href.includes('youtu.be/')) ){
				var regExp = /^.*(youtu.be\/|watch\?v=|\&v=)([^#\&\?]*).*/
				const match = el.href.match(regExp)
				const id = (match && match[2].length > 0) ? match[2] : null
				if(id){
					type = 'airthemeYoutube'
					src = 'https://www.youtube.com/embed/'+id
				}
			}else if( isVimeo && el.href.includes('vimeo.com/') ){
				type = 'airthemeVimeo'
				src = el.href.replace('vimeo.com/','player.vimeo.com/video/').split("?")[0].split("#")[0]
			}else if( isSpotify && (el.href.includes('open.spotify.com/track') || el.href.includes('open.spotify.com/album')) ){
				const url = el.href.replace('open.spotify.com/','open.spotify.com/embed/').split("?")[0].split("#")[0]
				type = 'airthemeSpotify'
				src = url+'?utm_source=generator&theme=0'
			}else if( isAudiomack && el.href.includes('audiomack.com/') ){
				if(el.href.includes('song')){
					type = 'airthemeAudiomackSong'
				}else if(el.href.includes('album')){
					type = 'airthemeAudiomackAlbum'
				}
				if(type){
					src = el.href.replace('audiomack.com/','audiomack.com/embed/').split("?")[0].split("#")[0]
				}
			}else if( isImages && /\.(jpg|jpeg|png|webp|avif|gif|svg)($|\?)/.test(el.href) ){
				type = 'image'
				isFullscreen = true
				isZoom = true
				isSlideshow = true
			}
			if(type){
				items.push({ el, ind: items.length, type, src })
			}
		})
		if(items.length > 0){
			isSlideshow = isSlideshow && items.length > 1
			boxes.push(<Box key={boxes.length} items={items} isFullscreen={isFullscreen} isSlideshow={isSlideshow} isZoom={isZoom} />)
		}
	})
	if(boxes.length > 0){
		function App(){
			return (
				<>{boxes}</>
			)
		}
		const lightboxEl = document.createElement("div")
		lightboxEl.classList.add('airtheme-lightbox-react')
		document.body.append(lightboxEl);
		ReactDOM.createRoot(lightboxEl).render(<App />)
	}
}
export default lightbox
